/**
 * =========================================================================================
 * PERFORMANCE - ToolBar
 * =========================================================================================
 * ToolBar
 **/

import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useLocation} from 'react-router-dom';
import * as Icon from 'ubs-icons';
import {COLOR} from "ubs-framework/v2/common/constant";
import {isElectron, isInApp} from "ubs-framework/v2/common/function";
import UPopup from "ubs-framework/v2/UPopup";
import GlobalSearch from "./global-search";
import {useEscKey} from "ubs-framework/v2/hooks";
import useSocket from "../../app-account/common/useSocket";
import UAvatar from "ubs-framework/v2/UAvatar";
import { getName } from 'ubs-framework/v2/common/function';
import {isMobileDevice} from "ubs-framework/v2/common/function";
import {sendData} from "../../store/actions";
import {eraseCookie} from 'ubs-framework/v2/common/function';

const ToolBar = () => {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();

    const _ORG_ID = useSelector(e => e.common.orgId);
    const _IA = useSelector(e => e.common.authData);
    const _S3_BASE_URL = useSelector(e => e.common.S3_BASE_URL);

    const [currentPath, setCurrentPath] = useState('');
    const [isGlobalSearchOpen, setIsGlobalSearchOpen] = useState(false);
    const splitData = location?.pathname?.split('/');
    const [popup, setPopup] = useState('');
    const [userInfoPopup, setUserInfoPopup] = useState({
        open: false,
        popup: false
    });
    const [pathArray, setPathArray] = useState([


        /*****************************************************************************/
        /** WorkSpace **/
        {name: 'workspace', path: ['Work Space']},

        /*****************************************************************************/
        /** Plans **/
        {name: 'plans', path: ['Plans']},
        {name: 'plans/manageplan', path: ['Plans', 'Manage Plan'] ,previous: 'plans'},

        /*****************************************************************************/
        // {name: 'setting', path: ['setting']},

    ]);

    // for Employee Profile
    useEffect(() => {
        let path_array = JSON.parse(JSON.stringify(pathArray));
        path_array = path_array?.map(path => {
            if (path?.route && path?.route === 'meetings-details') {
                path.name = `meetings/${splitData[3]}/${splitData[4]}`;
            } else if (path?.route && path?.route === 'add-meetings') {
                path.name = `meetings/add/${splitData[4]}`;
            } else if (path?.route && path?.route === 'add-evaluations') {
                path.name = `evaluations/add/${splitData[4]}`;
            } else if (path?.route && path?.route === 'edit-evaluations') {
                path.name = `evaluations/edit/${splitData[4]}`;
            } else if (path?.route && path?.route === 'view-evaluations-form') {
                path.name = `evaluations/edit/${splitData[4]}/view`;
            } else if (path?.route && path?.route === 'view-evaluations') {
                path.name = `evaluations/view/${splitData[4]}`;
            } else if (path?.route && path?.route === 'revise-request-detail') {
                path.name = `evaluations/revise/${splitData[4]}`;
            } else if (path?.route && path?.route === 'evaluation') {
                path.name = `evaluations/details/${splitData[4]}/${splitData[5]}`;
            } else if (path?.route && path?.route === 'view-objective') {
                path.name = `objectives/objective/okr/${splitData[5]}`;
            } else if (path?.route && path?.route === 'view-key-result') {
                path.name = `objectives/objective/kra/${splitData[5]}`;
            } else if (path?.route && path?.route === 'edit-access-level') {
                path.name = `settings/access-level/edit/${splitData[5]}`;
            } else if (path?.route && path?.route === 'edit-template') {
                path.name = `settings/evaluation-templates/edit/${splitData[5]}`;
            } else if (path?.route && path?.route === 'edit-question') {
                path.name = `settings/evaluation-templates/edit/questions/${splitData[6]}`;
            } else if (path?.route && path?.route === 'add-question') {
                path.name = `settings/evaluation-templates/add/questions/${splitData[6]}`;
            } else if (path?.route && path?.route === 'duplicate-template') {
                path.name = `settings/evaluation-templates/duplicate/${splitData[5]}`;
            } else if (path?.route && path?.route === 'generate-report') {
                path.name = `reports/${splitData[3]}`;
            } else if (path?.route && path?.route === 'report-details') {
                path.name = `reports/${splitData[3]}/view`;
            } else if (path?.route && path?.route === 'employee-average-report') {
                path.name = `reports/evaluation/${splitData[4]}`;
            } else if (path?.route && path?.route === 'evaluation-report-details') {
                path.name = `reports/evaluation/${splitData[4]}/view`;
            }
            return path;
        });

        setPathArray(path_array);
    }, [location]);
    const {off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case "":
                    break;
                default:
                    return true;
            }
        }
    });
    // Set Current path
    useEffect(() => {
        let path = location?.pathname?.slice(1);
        path = path?.slice(path.indexOf("/") + 1);
        setCurrentPath(pathArray?.find(_ => path === _.name));
    }, [location, pathArray]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest(".u_user-profile")) {
                setUserInfoPopup({ open: false });
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    useEffect(() => {
        refresh();
        return () => off();
    }, []);

    useEscKey(() => {
        if (popup?.length) setPopup('');
        setUserInfoPopup({open: false, popup: false})

    });
    // Redirect to previos page
    const redirectPrevious = (path) => {
        if (path?.previous === 'goback') {
            history?.goBack();
        } else {
            history.push(`/${_ORG_ID}/${currentPath?.previous}`);
        }
    }

    const getSidebar = () => {
        dispatch({type: 'OPEN_SIDEBAR', payload: true});
    }
    const setDashboardWidget = () => {
        dispatch({type: 'SET_DASHBOARD_WIDGETS_SIDEBAR', payload: true});
    }
    const handle = {
        toggleSearchBar: (flag) => {
            setIsGlobalSearchOpen(flag);
        }
    }
    const refreshList = () => {
        window.location.reload()
    }
    const getUserInfo = () => {
        setUserInfoPopup({open: !userInfoPopup?.open});
    }
    const onLogout = () => {
        if (localStorage.getItem('notification_token')) sendData(dispatch, 'logout', { device_token: localStorage.getItem('notification_token') })
        else sendData(dispatch, 'logout', {});
        dispatch({type: 'LOGOUT'})
        localStorage.clear()
        eraseCookie('ubs_token')
        eraseCookie('ubsTabId')
        history.push('/login')
        window.location.reload(true)
    }
    return (
        <React.Fragment>
            <div className={`u_project-header u_flex u_align-center u_content-between`} id="u_project-header">
                <div className="u_header-breadcrumb-wpr u_flex u_align-center">

                    {/** Mobile Toggle **/}
                    <button className="u_hrms-sidebar-toggle" onClick={getSidebar}>
                        <span/>
                    </button>

                    {/** Breadcrumbs **/}
                    <div className="u_flex u_align-center u_header-breadcrumb">
                        {
                            currentPath?.previous &&
                            <span className="u_icon-rollover u_header-breadcrumb-arrow u_mr-10 u_cp" onClick={() => redirectPrevious(currentPath)}>
                                <Icon.RightArrow size={16} fill={COLOR.u_blue}/>
                            </span>
                        }
                        <ul className="u_flex u_align-center u_flex-shrink">
                            {
                                currentPath?.path?.map((path, i) => {
                                    return <React.Fragment key={i}>
                                        {
                                            !path.includes('undefined') &&
                                            <li className={`${!currentPath?.previous ? 'u_py-5' : ''}`} onClick={() => currentPath?.previous ? redirectPrevious(currentPath) : ''}>
                                                {
                                                    path?.length > 30 ? <UPopup
                                                            params={{className: "u_tooltip", offsetX: 10}}
                                                            desc={<span>{path}</span>}
                                                        >
                                                            <span className="u_one-line">{path}</span>
                                                        </UPopup>
                                                        : path
                                                }
                                            </li>
                                        }
                                    </React.Fragment>
                                })
                            }
                        </ul>
                    </div>
                </div>

                {/** Global Search **/}
                {!isElectron() && <GlobalSearch open={isGlobalSearchOpen} closeSidebar={(data) => handle.toggleSearchBar(data)}/>}
                {/* Menu Options */}
                {/*<div className="u_header-options u_flex u_align-center u_content-end">*/}
                {/*    <div className="u_flex u_align-center u_project-menuicon">*/}
                {/*        */}
                {/*        <div className="u_global-search-input__mobile u_project-menuicon-inner">*/}
                {/*            /!* Global Search *!/*/}
                {/*            <span className="u_cp" onClick={() => handle.toggleSearchBar(true)}>*/}
                {/*                <Icon.Search size={18} fill={COLOR?.u_icon_bg}/>*/}
                {/*            </span>*/}
                {/*        </div>*/}

                {/*        /!* <div className="u_project-menuicon-inner">*/}
                {/*            <span className="u_header-chat-icon"/>*/}
                {/*        </div>*!/*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div className="u_flex-align u_content-end u_user-profile">
                    <div className="u_flex u_align-center u_cp u_mr-10" onClick={getUserInfo}>
                        <UAvatar
                            name={getName(_IA)}
                            image={_IA?.profileImage}
                            s3Url={_S3_BASE_URL}
                            width={36}
                            height={36}
                        />
                        <div className="u_pl-8 u_flex-align">
                            <p className="u_small-font u_one-line u_color-title u_text-bold">
                                Hi, {getName(_IA) || '-'}
                            </p>
                            <span className="u_ml-8 u_flex-align">
                                {userInfoPopup?.open
                                    ? <Icon.UpArrow size={10} fill={COLOR.u_icon_bg}/>
                                    : <Icon.DownArrow size={10} fill={COLOR.u_icon_bg}/>
                                }
                            </span>
                        </div>
                    </div>

                    {userInfoPopup?.open && (
                        <div className="u_user-profile-signout">
                            <div className="u_p-16 u_bb-light">
                                <p className="u_small-font u_color-title">{getName(_IA) || '-'}</p>
                                <p className="u_font u_mt-4">{_IA?.email || '-'}</p>
                            </div>
                            <div className="u_py-8">
                                <div className="u_px-16 u_py-10 u_flex u_align-center u_cp" onClick={onLogout}>
                                    <Icon.Out size={20} fill={COLOR.u_red}/>
                                    <p className={"u_small-font u_ml-15 u_color-red u_text-bold"}>Sign Out</p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
}

export default ToolBar;
